"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const CarbonTx = __importStar(require("../../../util/tx"));
const utils_1 = require("../utils");
const TxTypes = {
    CreatePool: "perpspool/CreatePool",
    UpdatePool: "perpspool/UpdatePool",
    DepositToPool: "perpspool/DepositToPool",
    RegisterToPool: "perpspool/RegisterToPool",
    DeregisterToPool: "perpspool/DeregisterToPool",
    WithdrawFromPool: "perpspool/WithdrawToPool",
    UpdateMarketConfig: "perpspool/UpdateMarketConfig",
};
const MsgCreatePool = {
    aminoType: TxTypes.CreatePool,
    valueMap: {},
};
const MsgUpdatePool = {
    aminoType: TxTypes.UpdatePool,
    valueMap: {
        poolId: utils_1.ConvertEncType.Long,
    },
};
const MsgRegisterToPool = {
    aminoType: TxTypes.RegisterToPool,
    valueMap: {
        poolId: utils_1.ConvertEncType.Long,
    },
};
const MsgDeregisterFromPool = {
    aminoType: TxTypes.DeregisterFromPool,
    valueMap: {},
};
const MsgDepositToPool = {
    aminoType: TxTypes.DepositToPool,
    valueMap: {
        poolId: utils_1.ConvertEncType.Long,
    },
};
const MsgWithdrawFromPool = {
    aminoType: TxTypes.WithdrawFromPool,
    valueMap: {
        poolId: utils_1.ConvertEncType.Long,
    },
};
const PerpspoolAmino = {
    [CarbonTx.Types.MsgCreatePool]: utils_1.generateAminoType(MsgCreatePool),
    [CarbonTx.Types.MsgUpdatePool]: utils_1.generateAminoType(MsgUpdatePool),
    [CarbonTx.Types.MsgRegisterToPool]: utils_1.generateAminoType(MsgRegisterToPool),
    [CarbonTx.Types.MsgDeregisterFromPool]: utils_1.generateAminoType(MsgDeregisterFromPool),
    [CarbonTx.Types.MsgDepositToPool]: utils_1.generateAminoType(MsgDepositToPool),
    [CarbonTx.Types.MsgWithdrawFromPool]: utils_1.generateAminoType(MsgWithdrawFromPool),
};
exports.default = PerpspoolAmino;
